import { IClient } from "@wingspanhq/users/dist/lib/interfaces";
import { PaymentMethod } from "../steps/PaymentMethod";
import {
  OnboardingContext,
  OnboardingModulePaymentMethod,
  OnboardingStep,
  OnboardingStepStatus
} from "../types";

const getStatus = (client?: IClient): OnboardingStepStatus => {
  const hasPaymentMethod =
    !!client?.profile.defaultPaymentMethod?.accountId ||
    !!client?.profile.defaultPaymentMethod?.paymentMethodId;

  if (hasPaymentMethod) {
    return "Complete";
  }

  return "None";
};

export const getPaymentMethodStepConfig = (
  _: OnboardingModulePaymentMethod,
  __: OnboardingContext,
  client?: IClient
): OnboardingStep => {
  const status = getStatus(client);

  return {
    title: "Payment method",
    slug: "payment-method",
    component: PaymentMethod,
    status,
    result: {
      Complete: {
        title: "Your payment method was added",
        description:
          "The payment method was added and can be used to send payments. Click continue for the next step."
      }
    }
  };
};
